import { createCommand } from "lexical"
import { v4 as uuid } from "uuid"

export const TOGGLE_SEARCH_PANEL = createCommand()
export const REPLACE_ALL = createCommand("REPLACE_ALL")
export const REPLACE_SINGLE = createCommand("REPLACE_SINGLE")
export const getMatchingEndStart = (str1, str2) => {
  const minLength = Math.min(str1.length, str2.length)

  // Приводим строки к нижнему регистру
  const lowerStr1 = str1.toLowerCase()
  const lowerStr2 = str2.toLowerCase()

  // Проверяем совпадение от самой короткой длины до нуля
  for (let i = 1; i <= minLength; i++) {
    const endOfStr1 = lowerStr1.slice(-i)
    const startOfStr2 = lowerStr2.slice(0, i)

    if (endOfStr1 === startOfStr2) {
      return str1.slice(-i) // Возвращаем совпадающую часть оригинальной строки
    }
  }

  return "" // Если совпадений нет
}
export const getMatchingStart = (str1, str2) => {
  const minLength = Math.min(str1.length, str2.length)
  const lowerStr1 = str1.toLowerCase()
  const lowerStr2 = str2.toLowerCase()

  // Проверяем совпадение от максимальной длины до минимальной
  for (let i = minLength; i > 0; i--) {
    const startOfStr1 = lowerStr1.slice(0, i)
    const startOfStr2 = lowerStr2.slice(0, i)

    if (startOfStr1 === startOfStr2) {
      return str1.slice(0, i) // Возвращаем совпадающую часть оригинальной строки
    }
  }

  return "" // Если совпадений нет
}

export const replaceLastNChars = (str, n, str2) => {
  // Если n больше длины строки, просто вернем str2
  if (n > str.length) {
    return str2
  }
  // Обрезаем строку до длины str.length - n и добавляем str2
  return str.slice(0, -n) + str2
}

export const removeFirstNChars = (str1, n) => {
  // Проверяем, чтобы n не превышало длину строки
  if (n > str1.length) {
    return "" // Если n больше длины строки, вернем пустую строку
  }
  return str1.slice(n)
}
export const findAllSubstringIndices = (str1, str2, node) => {
  const indices = []

  // Приводим строки к нижнему регистру
  const lowerStr1 = str1.toLowerCase()
  const lowerStr2 = str2.toLowerCase()

  let startIndex = lowerStr1.indexOf(lowerStr2)

  while (startIndex !== -1) {
    const endIndex = startIndex + str2.length - 1
    indices.push({ startIndex, endIndex, nodesData: [node], id: uuid() })
    startIndex = lowerStr1.indexOf(lowerStr2, startIndex + 1)
  }

  return indices
}

export const replaceSubstring = (str1, str2, startIndex, endIndex) => {
  // endIndex включительно, поэтому корректируем диапазон
  if (startIndex < 0 || endIndex >= str1.length || startIndex > endIndex) {
    throw new Error("Некорректные индексы")
  }

  const beforeSubstring = str1.slice(0, startIndex)
  const afterSubstring = str1.slice(endIndex + 1) // endIndex включительно

  return beforeSubstring + str2 + afterSubstring
}

export const escapeRegExp = (string) => {
  return string.replace(/[-[\]{}()*+?.,\\^$|#]/g, "\\$&")
}
